import makeLevel from '../makeLevel.js';
import * as powerups from '../../powerups.js';

export default makeLevel([
  "                    ",
  "                    ",
  "                    ",
  "*                  *",
  " **              ** ",
  "   ***        ***   ",
  "     *********  *   ",
  "     *     *    *   ",
  "     *     *   0!0  ",
  "    0!0   0!0  0 0  ",
  "    0 0   0 0   0   ",
  "     0     0        ",
  "                    ",
  "                0   ",
  "   0           0 0  ",
  "  0 0          0!0  ",
  "  0!0           *   ",
  "   *            ****",
  "****              **",
  "**                  ",
], [
    {
        "4": powerups.paddleShrink,
        "5": powerups.paddleGrow,
        "12": powerups.ballSpeedUp,
        "19": powerups.paddleGrow,
        "21": powerups.paddleShrink,
        "23": powerups.paddleSticky,
        "25": powerups.ballExploding,
        "27": powerups.extraLive,
        "29": powerups.ballSpeedUp,
        "33": powerups.ballExtra,
        "34": powerups.paddleLasers,
        "35": powerups.ballExploding,
        "37": powerups.ballSpeedUp,
        "41": powerups.paddleLasers,
        "49": powerups.paddleSticky,
        "62": powerups.ballSpeedUp,
        "63": powerups.skipLevel,
        "64": powerups.paddleShrink,
        "67": powerups.ballExtra
    },
    {
        "6": powerups.ballSpeedDown,
        "8": powerups.paddleLasers,
        "16": powerups.instaDeath,
        "25": powerups.ballUnstopable,
        "29": powerups.ballSpeedUp,
        "32": powerups.instaDeath,
        "44": powerups.ballSpeedUp,
        "48": powerups.ballSpeedUp,
        "59": powerups.ballExploding,
        "63": powerups.ballSpeedDown,
        "64": powerups.paddleGrow,
        "67": powerups.ballExtra,
        "69": powerups.paddleShrink
    },
    {
        "9": powerups.lightning,
        "15": powerups.ballSpeedUp,
        "20": powerups.ballUnstopable,
        "21": powerups.paddleSticky,
        "24": powerups.lightning,
        "36": powerups.paddleLasers,
        "38": powerups.ballSpeedUp,
        "46": powerups.extraLive,
        "48": powerups.ballExploding,
        "51": powerups.ballUnstopable,
        "52": powerups.paddleShrink,
        "59": powerups.ballSpeedDown
    },
    {
        "5": powerups.paddleMini,
        "6": powerups.ballExploding,
        "12": powerups.ballSpeedDown,
        "26": powerups.paddleGrow,
        "31": powerups.paddleMini,
        "37": powerups.paddleGrow,
        "40": powerups.weakenBlocks,
        "46": powerups.ballSpeedDown,
        "69": powerups.ballSpeedUp
    }
]);
